import React from "react";
import classNames from "classnames";

/**
 * Kinsa check glyph. Larger viewBox + thicker stroke; sizes to half of its
 * container (h-1/2 w-1/2) because the Kinsa checkbox is typically 24×24.
 * The sizing class is merged with the caller's className (not overridden
 * via `{...props}`) so WebKit doesn't collapse the SVG to 0×0 when a
 * caller passes only a text-color class. Stroke inherits from
 * `currentColor` so callers control color via `text-*`.
 */
const KinsaCheck: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  ...rest
}) => (
  <svg
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
    className={classNames("h-1/2 w-1/2 shrink-0", className)}
    {...rest}
  >
    <path
      d="M11.5 4L5.5 10L2.5 7"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KinsaCheck;
